import { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import MiniHeading from '../components/MiniHeading';
import { FormGroup } from '../../../../Components/FormGroup/FormGroup';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { toast } from 'react-toastify';
import { VscLoading } from 'react-icons/vsc';

import { resetPinValidation } from '../../../../_helpers/schema-validation';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormattedMessage } from 'react-intl';

function UpdatePin() {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(resetPinValidation)
  });

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await fetchWrapper.post('/reset-password/', {
        pin: data.confirm_pin
      });
      toast.success(<FormattedMessage id="security.pin_updated_successfully" />);

      setValue('new_pin', '');
      setValue('confirm_pin', '');
      setLoading(false);
    } catch (err) {
      toast.error('Something went wrong');
      setLoading(false);
      console.log(err);
    }
  };
  return (
    <div>
      <MiniHeading id="security.update-pin" />
      <div className="p-2">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={2} className="d-flex align-items-center">
              <FormattedMessage id="security.new-pin" />
            </Col>
            <Col md={3}>
              <FormattedMessage id="security.new-pin_placeholder">
                {(msg) => (
                  <FormGroup
                    type="password"
                    id="new_pin"
                    placeholder={msg}
                    max={4}
                    passwordType={'pin'}
                    register={register}
                    disabled={loading}
                    error={errors}
                  />
                )}
              </FormattedMessage>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={2} className="d-flex align-items-center">
              <div>
                <FormattedMessage id="security.confirm-pin" />
              </div>
            </Col>
            <Col md={3}>
              <FormattedMessage id="security.confirm-pin_placeholder">
                {(msg) => (
                  <FormGroup
                    type="password"
                    id="confirm_pin"
                    placeholder={msg}
                    max={4}
                    passwordType={'pin'}
                    register={register}
                    disabled={loading}
                    error={errors}
                  />
                )}
              </FormattedMessage>
            </Col>
          </Row>
          <Row className="mt-4">
            <div>
              <Button disabled={loading} type="submit">
                {loading ? (
                  <VscLoading className="spin" />
                ) : (
                  <FormattedMessage id="security.update-pin" />
                )}
              </Button>
            </div>
          </Row>
        </form>
      </div>
    </div>
  );
}

export default UpdatePin;
